import linq from 'linq'
import { snakeToCamel, camelToSnake } from '../utility/stringUtility'
import Category from './Category'
import Pattern from './Pattern'
import Model from './Parents/Model'
import ProductRecommendItem from './ProductRecommendItem'
import Tag from './Tag'

const FILLABEL = ['id', '_name', 'description', 'stock', 'imgPath', 'pattern']

export default class Product extends Model {
    constructor(data = null) {
        super()
        this.originalData = data

        this.id = 0
        this.description = ''
        this.stock = 0
        this.hasSubs = false
        this.imgPath = ''

        this._name = ''
        this.categories = []
        this.pattern = new Pattern()
        this.productRecommendItems = []
        this.icons = []
        this.tags = []

        if (data) {
            this.create()
        }
    }

    get _model() {
        return 'Product'
    }

    get isView() {
        return this.stock
    }

    set isView(val) {
        this.stock = Number(val)
    }

    get roundDescription() {
        if (this.description.length > 30) {
            return this.description.substring(0, 30) + '...'
        }
        return this.description.substring(0, 30)
    }

    get name() {
        if (!this.data) {
            return this.pattern.name
        }
        return this.pattern.id ? this.pattern.name : this.data.name
    }

    set name(val) {
        this._name = val
        this.pattern.name = val
    }

    create() {
        linq.from(this.data)
            .select((x) => {
                x.key = camelToSnake(x.key)
                return x
            })
            .where((x) => this.hasOwnProperty(snakeToCamel(x.key)) || x.key === 'name')
            .where((x) => x.value)
            .select((x) => {
                const key = snakeToCamel(x.key)

                if (typeof this[key] === 'number') {
                    this[key] = Number(x.value)
                    return
                }

                if (key === 'categories') {
                    this[key] = linq
                        .from(x.value)
                        .select((x) => new Category(x))
                        .toArray()
                    return
                }

                if (key === 'pattern') {
                    this[key] = new Pattern(x.value)
                    return
                }

                if (key === 'product_recommend_items') {
                    this[key] = linq
                        .from(x.value)
                        .select((x) => new ProductRecommendItem(x))
                        .toArray()
                    return
                }

                if (key === 'tags') {
                    this[key] = linq
                        .from(x.value)
                        .select((x) => new Tag(x))
                        .toArray()
                    return
                }

                this[key] = x.value
                return x
            })
            .toArray()
    }

    get data() {
        return this.originalData
    }

    getPostable() {
        this.name = this.pattern.name
        return linq
            .from(this)
            .where((x) => linq.from(FILLABEL).any((xs) => xs === x.key))
            .where((x) => x.value || (typeof x.value === 'number' && x.key === 'stock'))
            .select((x) => {
                let key = camelToSnake(x.key)
                let value = x.value

                if (key === 'pattern') {
                    value = value.getPostable()
                }

                if (key === '_name') {
                    key = 'name'
                }

                return {
                    key: key,
                    value: value,
                }
            })
            .toObject('$.key', '$.value')
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/models/Product.js